module.exports = __webpack_public_path__ + "media/images/writer/home/kv-bg-desktop@2x-7206c9e7c870f044fb9104c4c44296a5.png";